import React, { useState } from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Register from './pages/Register';
import NewOrder from './pages/NewOrder';
import MyOrders from './pages/MyOrders';
import Wallet from './pages/Wallet';
import TrackOrder from './pages/TrackOrder';
import RegisterCompany from './pages/RegisterCompany';

function AppContent() {
  const { user, token, loading, logout } = useAuth();
  const [page, setPage]               = useState('new');
  const [showReg, setShowReg]         = useState(false);
  const [activeOrder, setActiveOrder] = useState(null);

  const path = window.location.pathname;
  if (path === '/register-company') return <RegisterCompany />;

  if (loading) return (
    <div style={{display:'flex',justifyContent:'center',alignItems:'center',height:'100vh',fontSize:'24px'}}>⏳</div>
  );

  if (!user) return showReg
    ? <Register onSwitch={() => setShowReg(false)} />
    : <Login    onSwitch={() => setShowReg(true)} />;

  if (activeOrder) return (
    <TrackOrder order={activeOrder} token={token} onBack={() => setActiveOrder(null)} />
  );

  return (
    <div style={styles.app}>
      <div style={styles.content}>
        {page === 'new'     && <NewOrder token={token} onOrderCreated={(order) => { setActiveOrder(order); }} />}
        {page === 'wallet'  && <Wallet token={token} />}
        {page === 'orders'  && <MyOrders onTrack={(order) => setActiveOrder(order)} />}
        {page === 'profile' && (
          <div style={styles.profile}>
            <div style={styles.profileHeader}>
              <div style={styles.avatar}>👤</div>
              <h2 style={styles.userName}>{user.full_name}</h2>
              <p style={styles.userPhone}>{user.phone}</p>
            </div>
            <a href="/register-company" style={styles.companyLink}>🏢 انضم كشركة توصيل</a>
            <button style={styles.logoutBtn} onClick={logout}>🚪 تسجيل الخروج</button>
          </div>
        )}
      </div>
      <nav style={styles.nav}>
        {[['new','🚀','طلب جديد'],['orders','📋','طلباتي'],['wallet','💳','محفظتي'],['profile','👤','حسابي']].map(([id,ic,lb]) => (
          <button key={id} style={{...styles.navBtn,...(page===id?styles.navActive:{})}} onClick={() => setPage(id)}>
            <span style={styles.navIcon}>{ic}</span>
            <span style={styles.navLabel}>{lb}</span>
          </button>
        ))}
      </nav>
    </div>
  );
}

export default function App() {
  return <AuthProvider><AppContent /></AuthProvider>;
}

const styles = {
  app:           { display:'flex', flexDirection:'column', minHeight:'100vh', background:'#f5f6fa' },
  content:       { flex:1, overflowY:'auto', paddingBottom:'70px' },
  nav:           { position:'fixed', bottom:0, left:0, right:0, background:'#fff', display:'flex', borderTop:'1px solid #eee', boxShadow:'0 -2px 10px rgba(0,0,0,0.08)', zIndex:1000 },
  navBtn:        { flex:1, padding:'10px 5px', background:'none', border:'none', cursor:'pointer', display:'flex', flexDirection:'column', alignItems:'center', gap:'3px' },
  navActive:     { borderTop:'3px solid #10b981' },
  navIcon:       { fontSize:'22px' },
  navLabel:      { fontSize:'11px', color:'#888' },
  profile:       { padding:'30px 20px', direction:'rtl' },
  profileHeader: { background:'linear-gradient(135deg,#10b981,#059669)', borderRadius:'16px', padding:'30px', textAlign:'center', color:'#fff', marginBottom:'16px' },
  avatar:        { fontSize:'60px', marginBottom:'10px' },
  userName:      { margin:'0 0 5px', fontSize:'22px', fontWeight:'bold' },
  userPhone:     { margin:0, opacity:0.8, fontSize:'15px' },
  companyLink:   { display:'block', width:'100%', padding:'14px', background:'#f0f4ff', border:'1px solid #10b981', borderRadius:'12px', textAlign:'center', color:'#10b981', fontWeight:'bold', fontSize:'15px', textDecoration:'none', marginBottom:'12px', boxSizing:'border-box' },
  logoutBtn:     { width:'100%', padding:'14px', background:'#e74c3c', color:'#fff', border:'none', borderRadius:'12px', fontSize:'15px', fontWeight:'bold', cursor:'pointer' },
};
